import { typedStorage, type UserInfo } from '@/utils/storage'

/**
 * 开发环境 Mock 用户信息组件
 * 仅在开发环境自动设置 mock 用户信息到缓存中
 * 在非开发环境，如果 URL 中带有 uid 和 accesstoken 参数，则使用这些参数设置用户信息
 *
 * 注意：此逻辑在组件函数体顶部同步执行，确保在 API 请求之前设置缓存
 */
export default function DevMockUser() {
  // 同步执行，确保在组件渲染和 API 请求之前设置缓存
  if (typeof window !== 'undefined') {
    const isDev = process.env.NODE_ENV === 'development'

    if (isDev) {
      // uid: '100341'
      const uid = '100341'
      const token =
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJ5YXl5YSIsInN1YiI6ImFwcCIsImV4cCI6MTc3NTEyMTc5MSwibmJmIjoxNzcyNTI5NzkxLCJpYXQiOjE3NzI1Mjk3OTEsInVpZCI6MTAwMzQxLCJyZ24iOiJwayIsImlkdCI6MSwiY3BsIjp0cnVlLCJ0eXAiOjF9.Q1QhHQ49pq1DlVpU3nFwpwWQ-nDJIll-4PuRjob-bKA'
      // 开发环境：设置 Mock 用户信息
      const mockUserInfo: UserInfo = {
        avatarurl: 'https://via.placeholder.com/100',
        uid,
        nickname: 'faker',
        duid: uid,
        accesstoken: token,
      }

      // 设置到缓存中
      typedStorage.setUserInfo(mockUserInfo)
      console.log('[DevMockUser] Mock 用户信息已设置:', mockUserInfo)
    } else {
      // 非开发环境：从 URL 参数中获取 uid 和 accesstoken
      const searchParams = new URLSearchParams(window.location.search)

      // 打印所有 URL 参数
      const allParams = Object.fromEntries(searchParams.entries())
      console.log('[DevMockUser] URL 所有参数:', allParams)

      const uid = searchParams.get('uid')
      const accesstoken = searchParams.get('accesstoken')

      // 如果 URL 中同时存在 uid 和 accesstoken，则设置到缓存中
      if (uid && accesstoken) {
        const userInfo: UserInfo = {
          avatarurl: '',
          uid: uid,
          nickname: '',
          duid: '',
          accesstoken: accesstoken,
        }

        // 设置到缓存中
        typedStorage.setUserInfo(userInfo)
        console.log('[DevMockUser] 从 URL 参数设置用户信息:', userInfo)
      }
    }
  }

  // 此组件不渲染任何内容
  return null
}
